import $ from 'jquery';
import Swiper from 'swiper/bundle';

// eslint-disable-next-line no-undef
const object = gralObject;

$('.recipes-block').each(function () {
    const el = $(this).find('.recipes-block__slider-smile')

    new Swiper(el[0], {
        slidesPerView: 1,
        watchOverflow: false,
        effect: 'fade',
        autoplay: {
            delay: 5000,
        },
    })
});

